<template>
  <div class="loyalty-status-history">
    <div class="text-h6 mb-2">
      История статусов
    </div>
    <div class="text--secondary text-body-2 mb-2">
      Статус квартала определяется баллами, заработанными в предыдущем квартале
    </div>
    <v-select
      :value="year"
      :items="yearOptions"
      label="Год"
      dense
      outlined
      hide-details
      :disabled="loading"
      class="loyalty-status-history__year"
      @change="$emit('year-change', $event)"
    />
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
      class="mt-3 mb-2"
    />
    <v-simple-table
      v-else-if="items.length"
      dense
      class="mt-3"
    >
      <template #default>
        <thead>
          <tr>
            <th class="text-left">
              Квартал
            </th>
            <th class="text-left">
              Период
            </th>
            <th class="text-left">
              Статус
            </th>
            <th class="text-right">
              Баллы (основание)
            </th>
            <th class="text-left">
              Квартал-основание
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in items"
            :key="`${item.quarter || index}-${item.period_label}`"
          >
            <td>{{ formatQuarterLabel(item.quarter) }}</td>
            <td>{{ item.period_label || '—' }}</td>
            <td>{{ item.loyalty_status_label || '—' }}</td>
            <td class="text-right">
              {{ item.basis_points != null ? item.basis_points : '—' }}
            </td>
            <td>{{ formatBasisPeriodLabel(item.basis_period) }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div
      v-else
      class="text--secondary text-body-2 mt-3"
    >
      Нет данных за выбранный год
    </div>
  </div>
</template>

<script>
import {
  formatBasisPeriodLabel,
  formatQuarterLabel,
} from '@/views/club_player/loyaltyConstants'

export default {
  name: 'LoyaltyStatusHistoryBlock',
  props: {
    year: {
      type: Number,
      required: true,
    },
    yearOptions: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatQuarterLabel,
    formatBasisPeriodLabel,
  },
}
</script>

<style scoped>
.loyalty-status-history__year {
  max-width: 160px;
}
</style>
